import * as React from "react"
import { Carousel } from "../Carousel"
import * as ReactDOM from "react-dom"
import { Theme } from "../../entryes/panel/MUI"
import { ThemeProvider, Link as MUILink, makeStyles } from "@material-ui/core"
import useLocalStorage from "../../hooks/useLocalStorage"
import { Icon } from "../Icon"
import CloseFatRoundedIcon from "../Icons/closeFatRounded"


export interface ATBannerCarouselProps {
  banners: Array<IBanner>;
  rotateTimeout: number;
  autoRotate: boolean;
  hideControls: boolean;
}

export const ATBannerCarousel: React.FC<ATBannerCarouselProps> = ({
  banners,
  autoRotate = true,
  rotateTimeout = 1200,
  hideControls = false,
}) => {
  const [open, setOpen] = useLocalStorage("banner-simpe-image_closed", true);
  const classes = useStyles();
  if (!open) {
    return null;
  }
  return (
    <div className={classes.root}>
      <CloseFatRoundedIcon className={classes.icon} onClick={(e: any) => setOpen(false)} />
      <Carousel hideControls={hideControls} autoRotate={autoRotate} rotateTimeout={rotateTimeout}>
        {banners.map((banner) => (
          <MUILink className={classes.banner} key={banner.url} href={banner.url} target="_blank">
            <img key={banner.url} width="230" height="auto" src={banner.image} alt="banner" />
          </MUILink>
        ))}
      </Carousel>
    </div>
  )
}

const useStyles = makeStyles((theme) =>({
  root: {
    marginBottom: 12,
    position: 'relative',
  },
  banner: {
    overflow: 'hidden',
    width: 230,
    height: '100%',
    '& img': {
      borderRadius: theme.shape.borderRadius,
      width: 230,
      height: 'auto',
    }
  },
  icon: {
    position: 'absolute',
    right: 8,
    top: 8,
    zIndex: 1,
    color: '#d3d3d3',
    fontSize: 12,
    cursor: 'pointer',
  }
}))


interface IBanner {
  image: string;
  url: string;
}

window.render_at_banner_carousel = function(nodeId: string, props: ATBannerCarouselProps ) {
  ReactDOM.render(
    <ThemeProvider theme={Theme}>
      <ATBannerCarousel  {...props} />
    </ThemeProvider>,
    document.getElementById(nodeId)
  )
}